module.exports = __webpack_public_path__ + "img/download1.c072feed.png";